import {
    AdvancedFilterFieldTypesEnum,
    AdvanceFilterParamType,
    IAdvanceFilter,
    IConditionAdvancedFilter,
    IGeneralDataAdvancedFilter,
    IOrganizationDataAdvancedFilter,
    IPersonDataAdvancedFilter
} from "../../../shared/advanced-filters/components/advance-filter";
import {IMetadataItemDto} from "../../settings/documentfields/metadata-item.dto";
import {OwnerFilterType} from "../dto/document-listing.dto";
import {IAdvancedSearchRequest, IDocumentFilterState} from "./document-listing.reducers";
import {RequestBuilder} from "./request-builder";

export class GetDocumentsRequestBuilder extends RequestBuilder<IAdvancedSearchRequest>{
    private readonly noCategoryId = -1;
    private readonly noCategoryValue = 'no_category';

    setBasicFilter(filters: IDocumentFilterState){
        
        if (filters?.perPageRecords) {
            this.request = {
                ...this.request,
                per_page_records: filters.perPageRecords
            }
        }

        if (filters?.status) {
            this.request = {
                ...this.request,
                status: filters.status
            }
        }

        if (filters?.dateFrom) {
            this.request = {
                ...this.request,
                date_from: filters.dateFrom
            }
        }

        if (filters?.dateTo) {
            this.request = {
                ...this.request,
                date_to: filters.dateTo
            }
        }

        if (filters?.documentTypeId) {
            this.request = {
                ...this.request,
                document_type_id: filters.documentTypeId
            }
        }

        if (filters?.userFilter) {
             if(filters.userFilter.id && (filters.userFilter.group === OwnerFilterType.user || filters.userFilter.group === OwnerFilterType.me)){
                this.request = {
                    ...this.request,
                    owner_id: filters.userFilter.id as number
                }
            }else if(filters.userFilter.group === OwnerFilterType.group) {
                this.request = {
                    ...this.request,
                    owners_from_group_id: filters.userFilter.id as number
                }
            }
        }

        if (filters?.categoryId === this.noCategoryId) {
            this.request = {
                ...this.request,
                category_id: this.noCategoryValue
            }
        } else if (filters?.categoryId) {
            this.request = {
                ...this.request,
                category_id: filters.categoryId
            }
        }

        return this;
    }

    setAdvancedFilter(advanced: IAdvanceFilter<AdvanceFilterParamType>[]){
        if (advanced?.length > 0) {
            this.request = {
                ... this.request,
                advanced: advanced
                    .map(adv => {
                        return this.createAdvanceFilterPayload(adv)
                    })
            }
        }

        return this;
    }


    private createAdvanceFilterPayload(adv: IAdvanceFilter<AdvanceFilterParamType>): AdvanceFilterParamType {
        switch (adv.field_type) {
            case AdvancedFilterFieldTypesEnum.general_field: {
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.general_field,
                    value: adv.value,
                    operator: adv.operator,
                    general_data_type: (adv.item as IGeneralDataAdvancedFilter).general_data_type,
                }) as IGeneralDataAdvancedFilter
            }

            case AdvancedFilterFieldTypesEnum.person_field:
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.person_field,
                    person_data_type: (adv.item as IPersonDataAdvancedFilter).person_data_type,
                    value: adv.value,
                    operator: adv.operator,
                }) as IPersonDataAdvancedFilter

            case AdvancedFilterFieldTypesEnum.organization_field:
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.organization_field,
                    organization_data_type: (adv.item as IOrganizationDataAdvancedFilter).organization_data_type,
                    value: adv.value,
                    operator: adv.operator,
                }) as IOrganizationDataAdvancedFilter


            case AdvancedFilterFieldTypesEnum.document_field:
                return ({
                    field_type: adv.field_type,
                    meta_data_id: (adv.item as IMetadataItemDto).id,
                    value: adv.value,
                    operator: adv.operator,
                    condition_type: adv.condition_type
                } as AdvanceFilterParamType);


            case AdvancedFilterFieldTypesEnum.condition:
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.condition,
                    condition_type: adv.condition_type
                } as IConditionAdvancedFilter);
        }
    }

    build(): IAdvancedSearchRequest {
        return super.build();
    }
}
